var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"fill":"none","height":_vm.height,"viewBox":"0 0 8 16","width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 0H0V16H8V0Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }